import React, { useState, useCallback, useMemo } from 'react'
import { down } from 'styled-breakpoints'
import styled, { css } from 'styled-components'
import useInputs from '../../hooks/useInputs'
import { TABLET } from '../../lib/constant'
import Input from '../common/Input'
import Select from '../common/Select'

const options = [
	{ label: '지역 사업자 제휴', value: '1' },
	{ label: '서비스지역 확장 제안', value: '2' },
	{ label: '기타', value: '3' },
]

export default function ContactFormSection() {
	const [{ name, email, content }, onChangeInput, onReset] = useInputs({
		name: '',
		email: '',
		content: '',
	})

	const [selectedCategory, setSelectedCategory] = useState(null)
	const onChangeSelect = useCallback((option) => {
		setSelectedCategory(option.value)
	}, [])

	const form = useMemo(
		() => ({
			name,
			email,
			content,
			selectedCategory,
		}),
		[name, email, content, selectedCategory]
	)

	const canSubmit = useMemo(
		() => !(name === '' || email === '' || content === ''),
		[name, email, content]
	)

	const onSubmit = useCallback(() => {
		if (!canSubmit) return null
		// TODO: submit action
		onReset()
	}, [form])

	return (
		<Section>
			<Left>
				<li>
					<p className="key">이메일 주소</p>
					<p className="value">tagoga@dgood.co.kr</p>
				</li>
				<li>
					<p className="key">고객센터 운영시간</p>
					<p className="value">09:00 ~ 17:00</p>
				</li>
			</Left>
			<ContactForm>
				<Select
					options={options}
					placeholder="문의 카테고리"
					onChange={onChangeSelect}
				/>
				<Inputs>
					<Input
						placeholder="이름"
						name="name"
						value={name}
						onChange={onChangeInput}
					/>
					<Input
						placeholder="이메일 주소"
						name="email"
						value={email}
						onChange={onChangeInput}
					/>
				</Inputs>
				<Input
					placeholder="문의내용을 입력해주세요"
					name="content"
					className="textarea"
					value={content}
					onChange={onChangeInput}
					isTextarea
				/>
				<SubmitButton onClick={onSubmit} canSubmit={canSubmit}>
					제출하기
				</SubmitButton>
			</ContactForm>
		</Section>
	)
}

const Section = styled.section`
	max-width: 1012px;
	width: 100%;
	margin: 0 auto;
	display: flex;
	justify-content: space-between;
	padding: 0 16px;
	margin-top: 80px;

	${down(TABLET)} {
		flex-direction: column;
		align-items: center;
	}
`

const Left = styled.ul`
	> li {
		:first-child {
			margin-bottom: 32px;
		}
		> .key {
			font-size: 14px;
			font-weight: 700;
			line-height: 18px;
		}
		> .value {
			font-weight: 400;
			font-size: 16px;
			line-height: 20px;
			margin-top: 8px;
		}
	}

	${down(TABLET)} {
		margin-bottom: 32px;
		align-self: flex-start;
	}
`

const ContactForm = styled.div`
	max-width: 580px;
	width: 100%;
	display: flex;
	flex-direction: column;

	> .textarea {
		margin-top: 8px;
		height: 248px;
	}
`

const Inputs = styled.div`
	display: flex;
	margin-top: 8px;

	> *:first-child {
		margin-right: 8px;
	}
`

const SubmitButton = styled.button`
	font-size: 18px;
	font-weight: 700;
	line-height: 22px;
	border: none;
	border-radius: 104px;
	padding: 12px 24px;
	margin-top: 16px;
	cursor: pointer;
	align-self: flex-end;

	${({ canSubmit }) =>
		canSubmit
			? css`
					color: white;
					border: 1px solid transparent;
					background-color: black;
			  `
			: css`
					cursor: not-allowed;
					color: ${({ theme }) => theme.colors.gray[200]};
					border: 1px solid ${({ theme }) => theme.colors.gray[200]};
					background-color: white;
			  `}

	${down(TABLET)} {
		width: 100%;
	}
`
